import { render, staticRenderFns } from "./ParticularSucceed.vue?vue&type=template&id=635a336a&scoped=true&"
import script from "./ParticularSucceed.vue?vue&type=script&lang=js&"
export * from "./ParticularSucceed.vue?vue&type=script&lang=js&"
import style0 from "./ParticularSucceed.vue?vue&type=style&index=0&id=635a336a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a336a",
  null
  
)

export default component.exports